/* template */
<template minapp="mpx" xlang="wxml"><div><div v-for="(order, index) in (processingOrderList)" :key="order.index" class="card-container"><div :class="(order.isAllGray && 'gray')" class="train-information-new-card" v-if="(!order.isAllChanged)"><div :style='["z-index:1;position:relative"] | transRpxStyle'><train-information-new :trainInfo="(order)" :isTransfer="(isTransfer)" :showDate="(hasSeat)" :checkIn="(getCheckIn(order))" @click="showStayInfo(order)" showRecommend><template slot="footerSlot"><train-order-information-ticket :order="(order)" :hasSeat="(hasSeat)" @refresh="refresh"/></template></train-information-new></div></div></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m55870adc"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-user-order-information
    box-sizing border-box
    padding 16px 12px
    background #ffffff
    display flex
    justify-content space-between
    border-bottom 1px #F0F1F4 solid
    .custom-class
      width 100%
    /deep/ .label-class
      width 100%
      margin-left 0 !important
    .label-class
      width 100%
      margin-left 0 !important
      display flex
      justify-content space-between
    .es-user-order-info
      display flex
      width 100%
      justify-content space-between
    .es-user-order-info-left
      display flex
      flex-direction column
    .es-user-order-info-left
      text-align left
      .order-info-seat, .order-info-username
        font-size 16px
        font-weight 600
        line-height 22px
        &.noSeat
          margin-top 2px
        &.hasSeat
          margin-top 6px
      .order-info-id
        margin-top 4px
        font-size 14px
        font-weight 400
        line-height 20px
        color $train-color-666
      .order-info-beside-window, .order-info-silent
        display inline-block
        border 1px solid #0d50b2
        border-radius 2px
        font-size 10px
        font-weight 400
        height 14px
        line-height 16px
        color #0d50b2
        transform scale(0.9)
        text-align center
        margin-left 4px
      .order-info-beside-window
        width 24px
      .order-info-silent
        width 14px
    .es-user-order-info-right
      display flex
      flex-direction column
      text-align right
      justify-content space-between
      min-width 105px
      align-items flex-end
      .order-info-price
        font-size 16px
        font-weight normal
        font-family PingFangSC-Medium
        color $train-color-theme-blue
      .order-info-state, .order-info-tip, .order-info-ticket-check
        font-size 12px
        font-weight 400
        line-height 14px
        display flex
        flex-direction row
        align-self flex-end
        color $train-color-666
      .order-info-ticket-operate
        display flex
        align-items center
        .btn
          display flex
          align-items center
          padding 5px 8px
          background-color #F0F1F4
          border-radius 4px
          color #333
          font-family PingFangSC-Regular
          font-size 12px
          font-weight normal
          letter-spacing 0px
          &+.btn
            margin-left 8px
  .train-information-new-card
    padding 0px 12px 12px
    background #FFFFFF
    margin 0 -12px
  .card-container
    &:last-child
      margin-bottom 10px
.gray
  opacity 0.6
	
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m55870adc"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex55870adc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex55870adc%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m55870adc"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index55870adc/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'train-order-information-ticket':getComponent(require("../../pages/order/components/train-order-information-ticket/index.mpx?isComponent&outputPath=components%2Findex0071e325%2Findex")),'train-information-new':getComponent(require("../train-information-new/index.mpx?isComponent&outputPath=components%2Findex7f4255a4%2Findex")),'es-radio':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/radio/index.mpx?isComponent&outputPath=components%2Findex1da48bb6%2Findex")),'es-radio-group':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/radio-group/index.mpx?isComponent&outputPath=components%2Findex10772dd7%2Findex")),'train-information-card':getComponent(require("../../pages/order/components/train-information-card/index.mpx?isComponent&outputPath=components%2Findex61e1896c%2Findex")),'train-order-information-passenger':getComponent(require("../../pages/order/components/train-order-information-passenger/index.mpx?isComponent&outputPath=components%2Findex61b33835%2Findex")),'train-information':getComponent(require("../train-information/index.mpx?isComponent&outputPath=components%2Findex791c59ca%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
